import { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { DEFAULT_MAP_CENTER, pickMapMarkerWgs84FromMapUrlResult } from '../utils/coordinateTool';
import { attachCoordAdapter, DATUM_WGS84 } from '../utils/dashboard/basemapCoord';

/**
 * 地图预览类型/全屏、legacy mapbox 副作用、mapurl 落点
 * （实际渲染走 MapView；保留原 mapContainer/mapRef 逻辑以零行为变更）
 */
export default function useCoordinateToolMap({
  result,
  mapUrlResult,
  activeTab,
  setMapCenter,
  mapMarker,
  setMapMarker
}) {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const mapUrlMarkerRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [mapType, setMapType] = useState('satelliteStreets');

  useEffect(() => {
    if (!mapRef.current && mapContainer.current) {
      mapRef.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-zh-v1',
        center: DEFAULT_MAP_CENTER,
        zoom: 10,
        attributionControl: false
      });
      // 坐标工具地图只用 Mapbox 样式（WGS84）
      attachCoordAdapter(mapRef.current, { datum: DATUM_WGS84, basemapId: 'coordinate-tool-mapbox' });
    }
    if (mapRef.current && mapType) {
      try {
        mapRef.current.setStyle(mapType);
        mapRef.current.once('style.load', () => {
          if (mapMarker) {
            if (mapUrlMarkerRef.current) mapUrlMarkerRef.current.remove();
            const marker = new mapboxgl.Marker({ color: '#d32f2f' })
              .setLngLat(mapMarker)
              .addTo(mapRef.current);
            mapUrlMarkerRef.current = marker;
            mapRef.current.setCenter(mapMarker);
          }
        });
      } catch (e) {
        // 忽略切换时的异常
      }
    }

    if (mapRef.current) {
      const markers = document.querySelectorAll('.mapboxgl-marker');
      markers.forEach(marker => marker.remove());
    }

    if (mapRef.current && result && result.converted) {
      new mapboxgl.Marker()
        .setLngLat([result.converted.lng, result.converted.lat])
        .addTo(mapRef.current);
      mapRef.current.setCenter([result.converted.lng, result.converted.lat]);
    }
  }, [result]);

  useEffect(() => {
    if (activeTab === 'mapurl' && mapUrlResult && mapUrlResult.coordinates) {
      // 预览地图是 WGS84：只有 GCJ02/BD09 坐标时先换成 WGS84 再落点
      const coordinates = pickMapMarkerWgs84FromMapUrlResult(mapUrlResult);

      if (coordinates && coordinates.lat && coordinates.lng) {
        setMapCenter([coordinates.lng, coordinates.lat]);
        setMapMarker({ lng: coordinates.lng, lat: coordinates.lat });
      }
    }
    if (activeTab !== 'mapurl') {
      setMapMarker(null);
    }
  }, [mapUrlResult, activeTab]);

  const handleFullScreen = () => {
    setIsFullScreen(fs => !fs);
    setTimeout(() => {
      if (!isFullScreen && mapRef.current) {
        mapRef.current.resize();
      }
    }, 300);
  };

  return {
    mapContainer,
    mapRef,
    mapUrlMarkerRef,
    isFullScreen,
    mapType,
    setMapType,
    handleFullScreen
  };
}
